<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center mb-3">
      <CSpinner color="info" grow />
    </div>
    <WidgetStatistic :data="statistic" />
    <CRow>
      <CCol xl="6">
        <WidgetTable title="TOP RANKING ผู้ที่อ่านสูงสุด" :data="readers" />
      </CCol>
      <CCol xl="6">
        <WidgetTable title="TOP RANKING ผู้ที่ฟังมากที่สุด" :data="listeners" />
      </CCol>
      <CCol xl="6">
        <WidgetTable
          title="TOP RANKING หนังสือที่ถูกฟังมากที่สุด"
          :data="bookListens"
        />
      </CCol>
      <CCol xl="6">
        <WidgetTable
          title="TOP RANKING บทความที่ถูกฟังมากที่สุด"
          :data="articleListens"
        />
      </CCol>
      <CCol xl="6">
        <WidgetTable title="Activity Log" :data="activityLogs" />
      </CCol>
      <CCol xl="6">
        <WidgetTable
          title="Upload Book / Article Activity"
          :data="activityUploads"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import WidgetStatistic from './widgets/WidgetStatistic'
import WidgetTable from './widgets/WidgetTable'

import apiDashboard from '@/apis/dashboard'

export default {
  name: 'Dashboard',
  components: {
    WidgetStatistic,
    WidgetTable
  },
  mounted() {
    this.getDashboard()
  },
  methods: {
    getDashboard() {
      this.loading = true

      apiDashboard
        .getDashboard()
        .then((result) => {
          const { data } = result

          this.statistic.push(
            {
              topic: 'หนังสือทั้งหมด',
              current: data.book.current,
              lastMonth: data.book.lastMonth,
              cols: 4,
              icon: 'fa fa-book'
            },
            {
              topic: 'บทความทั้งหมด',
              current: data.article.current,
              lastMonth: data.article.lastMonth,
              cols: 4,
              icon: 'fa fa-file'
            },
            {
              topic: 'User ทั้งหมด',
              current: data.user.current,
              lastMonth: data.user.lastMonth,
              cols: 4,
              icon: 'fa fa-user'
            },
            {
              topic: 'หนังสือที่เปิดอ่าน',
              current: data.bookOpened.current,
              lastMonth: data.bookOpened.lastMonth,
              cols: 3,
              icon: 'fa fa-book-open'
            },
            {
              topic: 'ร้องขอหนังสือใหม่',
              current: data.newBookRequested.current,
              lastMonth: data.newBookRequested.lastMonth,
              cols: 3,
              icon: 'fa fa-book'
            },
            {
              topic: 'หนังสือ Export สำเร็จ',
              current: data.bookExported.current,
              lastMonth: data.bookExported.lastMonth,
              cols: 3,
              icon: 'fa fa-file-download'
            },
            {
              topic: 'บทความ Export สำเร็จ',
              current: data.articleExported.current,
              lastMonth: data.articleExported.lastMonth,
              cols: 3,
              icon: 'fa fa-file-download'
            }
          )
          this.readers.rows = data.topRank.readers
          this.listeners.rows = data.topRank.listeners
          this.bookListens.rows = data.topRank.bookListens
          this.articleListens.rows = data.topRank.articleListens
          this.activityLogs.rows = data.topRank.activityLogs
          this.activityUploads.rows = data.topRank.activityUploads

          this.loading = false
        })
        .catch((error) => {
          this.loading = false
        })
    }
  },
  data() {
    return {
      loading: false,
      statistic: [],
      readers: {
        columns: [
          {
            label: 'ชื่อ - นามสกุล',
            field: 'name'
          },
          {
            label: 'จำนวนเวลาที่อ่าน',
            field: 'count',
            thClass: 'text-right',
            tdClass: 'text-right'
          }
        ],
        rows: []
      },
      listeners: {
        columns: [
          {
            label: 'ชื่อหนังสือ',
            field: 'name'
          },
          {
            label: 'จำนวนเวลาที่ฟัง',
            field: 'count',
            thClass: 'text-right',
            tdClass: 'text-right'
          }
        ],
        rows: []
      },
      bookListens: {
        columns: [
          {
            label: 'ชื่อหนังสือ',
            field: 'name'
          },
          {
            label: 'จำนวนครั้งที่อ่าน',
            field: 'count',
            type: 'number'
          }
        ],
        rows: []
      },
      articleListens: {
        columns: [
          {
            label: 'ชื่อบทความ',
            field: 'name'
          },
          {
            label: 'จำนวนครั้งที่อ่าน',
            field: 'count',
            type: 'number'
          }
        ],
        rows: []
      },
      activityLogs: {
        columns: [
          {
            label: 'Username',
            field: 'username'
          },
          {
            label: 'เวลา',
            field: 'createdAt'
          },
          {
            label: 'ประเภทผู้ใช้',
            field: 'type'
          },
          {
            label: 'สถานะ',
            field: 'status'
          }
        ],
        rows: []
      },
      activityUploads: {
        columns: [
          {
            label: 'ชื่อหนังสือ / บทความ',
            field: 'name'
          },
          {
            label: 'ชื่อ - สกุล',
            field: 'createdBy'
          },
          {
            label: 'ประเภท',
            field: 'type'
          },
          {
            label: 'เวลา',
            field: 'createdAt'
          },
          {
            label: 'สถานะ',
            field: 'status',
            tdClass: 'text-center'
          }
        ],
        rows: []
      }
    }
  }
}
</script>
